import Vue from 'vue';
import Vuetify from 'vuetify/lib';

const vuetify = new Vuetify({
  theme: {
    themes: {
      light: {
        primary: "#1b4538",
        secondary: "#b0bec5",
        accent: "#c4001e",
        error: "#b71c1c"
      }
    }
  }
});

Vue.use(Vuetify);

export default vuetify
